import { z } from 'zod';
import { deviceTypeNameEnum } from '@/features/devices/schemas/devices.schemas.ts';

const conditionSchema = z.object({
  fact: z.string().min(1, 'Parameter is required'),
  operator: z.string().min(1, 'Operator is required'),
  value: z.string().min(1, 'Value is required'),
});

const RULE_TYPES = ['plant', 'device'] as const;
const ruleTypeEnum = z.enum(RULE_TYPES);
export type EventRuleTypes = (typeof RULE_TYPES)[number];

const EVENT_RULES_STATUSES = ['disabled', 'enabled'] as const;
const eventRuleStatusesEnum = z.enum(EVENT_RULES_STATUSES);
export type EventRuleStatuses = (typeof EVENT_RULES_STATUSES)[number];

export const eventRuleBaseSchema = z.object({
  status: eventRuleStatusesEnum.default('enabled'),

  eventRuleId: z.string({ error: 'Event rule id required' }),

  companyId: z.string({
    error: 'Company ID is required',
  }),
  plantId: z.string({ error: 'Plant ID is required' }).min(1, 'Plant ID is required'),

  plantName: z.string({ error: 'Plant name is required' }).min(1, 'Plant name is required'),

  deviceId: z.string().optional(),
  deviceType: deviceTypeNameEnum.optional(),
  deviceSN: z.string().optional(),

  eventTitle: z
    .string({ error: 'Event title is required' })
    .min(3, 'Event title must be at least 3 characters')
    .max(30, 'Event title must be less than 30 characters'),

  eventTemplate: z
    .string({ error: 'Event template is required' })
    .min(10, 'Event template must be at least 10 characters')
    .max(160, 'Event template must be less than 160 characters'),
  eventPreviewTemplate: z
    .string({ error: 'Event preview template is required' })
    .min(10, 'Event preview template must be at least 10 characters')
    .max(160, 'Event preview template must be less than 160 characters'),

  ruleType: ruleTypeEnum,

  conditions: z.array(conditionSchema).min(1, 'At least one condition is required'),

  cooldownPeriod: z
    .number({ error: 'Cooldown period is required' })
    .min(60, 'Cooldown period must be at least 60 minutes')
    .max(10080, 'Cooldown period cannot exceed 7 days (10080 minutes)')
    .default(60),

  lastTriggeredAt: z.string().optional(),
  triggerCount: z.number().optional(),

  updatedAt: z.string().optional(),
  createdAt: z.string().optional(),
});

export type EventRule = z.infer<typeof eventRuleBaseSchema>;

export const eventRuleStatuses = [
  {
    value: 'enabled',
    label: 'Enabled',
    icon: undefined,
  },
  {
    value: 'disabled',
    label: 'Disabled',
    icon: undefined,
  },
];
